import { PRUEBA_GRATUITA } from '@/content/planesPrecios';

// Copy de Seccion_Precios que no es dato (D-18). Los importes, las cuotas y la prueba viven en
// planesPrecios.ts; aquí solo hay frases del lienzo, y cualquier cifra dentro de una frase se
// calcula a partir del módulo para que la sección no pueda contradecir a /precios ni al Offer.

export type VistaPrecios = 'individual' | 'clinica';

export const PESTANAS_TIPO_PLAN: readonly { readonly vista: VistaPrecios; readonly texto: string }[] = [
    { vista: 'individual', texto: 'Para ti' },
    { vista: 'clinica', texto: 'Para tu clínica' },
];

export const ETIQUETA_TIPO_PLAN = 'Tipo de plan';

export const TEXTO_TODAS_LAS_FUNCIONES = 'Todas las funciones incluidas';

export const TEXTO_CTA_PRUEBA = 'Empieza tu prueba gratuita';

export const MICROCOPIA_PRUEBA = `${PRUEBA_GRATUITA.dias} días gratis · sin tarjeta`;

export const TEXTO_ANTES_OCULTO = ' antes';

export const TEXTO_CTA_CLINICA = 'Crear tu clínica';

export function textoPorProfesional(importe: string): string {
    return `Sale a ${importe} € por profesional`;
}

// Lo que tiene cada licencia (Q-1): la cuota del asistente se pasa desde el plan de clínica. Las sesiones sin límite
// vuelven en 17-39: el backend exime del tope Starter a toda licencia de una clínica viva, propietario incluido
// (aplicaTopeStarter, 17-34). Es la frase del lienzo (Seccion_Precios).
export const EQUIVALENCIA_CLINICA = {
    inicio: 'Cada profesional tiene todo lo de Professional: ',
    sesiones: 'sesiones sin límite mensual',
    union: ' y ',
    preguntas: (cuota: number) => `${cuota} preguntas`,
    final: ' al asistente al mes.',
} as const;

export const VENTAJAS_EQUIPO: readonly string[] = [
    'Invitaciones a tu equipo que caducan',
    'Roles de administración claros',
    'Licencias y facturación en un solo sitio',
    'Los pacientes de cada terapeuta siguen siendo solo suyos',
];

export const CABECERA_SECCION_PRECIOS = {
    antetitulo: 'Precios',
    titulo: 'Todas las funciones en los dos planes. Solo cambia cuánto lo usas.',
    entradilla:
        'Starter y Professional incluyen lo mismo. La diferencia está en las sesiones que subes y las preguntas ' +
        'que le haces al asistente cada mes.',
    enlace: { texto: 'Ver los planes en detalle', href: '/precios' },
} as const;

export const TITULO_INCLUIDO = 'Incluido en Starter y en Professional';

// El h2 que solo oyen los lectores de pantalla cuando la sección va sin cabecera (/precios).
export const TITULO_OCULTO_PLANES = 'Planes';

export const NOTA_QUE_CUENTA = {
    destacado: '¿Qué cuenta como pregunta?',
    resto:
        ' Cada mensaje que envías al asistente y cada cosa que le pides generar: un informe, una propuesta para el ' +
        'plan o la interpretación de un test. Transcribir y analizar las sesiones no cuenta. El contador vuelve a ' +
        'cero el día 1 de cada mes.',
} as const;

export interface Sello {
    readonly texto: string;
    readonly trazo: string;
    /** La prueba sin tarjeta solo está verificada para los planes individuales: la vista de clínica no la anuncia. */
    readonly soloIndividual: boolean;
}

export const SELLOS_PRECIOS: readonly Sello[] = [
    {
        texto: `${PRUEBA_GRATUITA.dias} días gratis, sin tarjeta`,
        trazo: 'M2 4.5h12v8H2z M2 7h12 M4.5 10h3 M1.5 14.5l13-13',
        soloIndividual: true,
    },
    {
        texto: 'Sin permanencia: cancelas cuando quieras',
        trazo: 'M2.5 3.5h11v10h-11z M2.5 6.5h11 M5.5 2v3M10.5 2v3 M6 9.5l4 3M10 9.5l-4 3',
        soloIndividual: false,
    },
    {
        texto: 'Datos alojados en Europa, con DPA incluido',
        trazo: 'M8 1.5l5 2v4c0 3.2-2.2 5.6-5 7-2.8-1.4-5-3.8-5-7v-4z M5.8 8l1.6 1.6 3-3',
        soloIndividual: false,
    },
];

// «Más de cinco» porque la mayor clínica tiene cinco licencias. Lo vigila un test
// (precios/banda-ventas.test.ts) y no una comprobación al cargar el módulo: este módulo llega al
// navegador, y un throw aquí tumbaría la landing y /precios a todos los visitantes.
export const BANDA_VENTAS = {
    destacado: '¿Sois más de cinco?',
    resto: ' Escríbenos y preparamos un plan para tu equipo.',
    correo: 'ventas@therapyrecap.com',
} as const;
